import { render, staticRenderFns } from "./TamizajeCuestionario.vue?vue&type=template&id=fbe639f4&"
import script from "./TamizajeCuestionario.vue?vue&type=script&lang=js&"
export * from "./TamizajeCuestionario.vue?vue&type=script&lang=js&"
import style0 from "./TamizajeCuestionario.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports